import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {concatMap, filter, first, merge, switchMap} from 'rxjs';

import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {
  AccountResetRequestedEvent
} from "../../../../../shared/application/events/account/account-reset-requested.event";
import {UnlockBookingUseCase} from '../use-cases/unlock-booking.use-case';
import {BookingExitedEvent} from "../../../../../shared/application/events/booking/booking-exited.event";
import {GetActiveBookingUseCase} from "../use-cases/get-active-booking.use-case";
import {Booking} from "../../domain/models/booking.model";
import {BookingClosedEvent} from "../../../../../shared/application/events/booking/booking-closed.event";

@Injectable({providedIn: 'root'})
export class UnlockBookingSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly unlockBookingUseCase = inject(UnlockBookingUseCase);
  private readonly getActiveBookingUseCase = inject(GetActiveBookingUseCase);

  constructor() {
    merge(
      this.eventBus.ofType(AccountResetRequestedEvent),
      this.eventBus.ofType(BookingExitedEvent),
      this.eventBus.ofType(BookingClosedEvent),
    )
      .pipe(
        switchMap(() => this.getActiveBookingUseCase.execute().pipe(first())),
        filter((activeBooking): activeBooking is Booking => !!activeBooking),
        concatMap((activeBooking) => this.unlockBookingUseCase.execute(activeBooking)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
